var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportPortalFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.706 3.107v5.441l-6.117-6.426c2.063-.333 4.205.022 6.117.985zM10.823 6.13H3.915c1.199-1.69 3.18-2.938 5.144-3.628l3.53 3.628h-1.766zM3.176 7.294h5.883l-6.872 6.813a10.54 10.54 0 01.989-6.813zm14.706 5.09l3.58-3.68a10.282 10.282 0 00-3.58-4.985v8.665zm-2.497 9.176l-3.58-3.678h8.427a10.046 10.046 0 01-4.847 3.678zm2.497-7.626l-.343.354-2.354 2.418h5.64A10.457 10.457 0 0022 11.869c0-.676-.065-1.335-.186-1.975l-3.932 4.04zM2.588 15.198l3.53-3.627v8.464c-1.717-1.238-2.839-2.759-3.53-4.837zm7.258 2.57l-.346-.356-2.206-2.266v5.723a9.737 9.737 0 006.485.939l-3.933-4.04z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPortalFill);
export default __webpack_public_path__ + "47b116c512bfe8a678259ddd460c7525.svg";
export { ForwardRef as ReactComponent };